var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bs" },
    [
      _c("router-view", { attrs: { name: "content" } }),
      _vm._v(" "),
      _c("side-navigation"),
      _vm._v(" "),
      _vm.showRechargeModal === true
        ? _c("base-recharge-modal", {
            attrs: {
              show: _vm.showRechargeModal,
              "preferred-amount": _vm.rechargePreferableAmount,
            },
            on: {
              "on-close-recharge": function ($event) {
                _vm.showRechargeModal = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.editModalShow
        ? _c("edit-units", {
            attrs: { "order-id": _vm.editModalOrderId },
            on: {
              "close-modal": function ($event) {
                _vm.editModalShow = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("app-footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }